import { Link,classnames as cx } from "@mna/react";
import Form from "@mna/react-ui/Form";
import schema from "@mna/schema";
import { Trans } from "react-i18next";
import i18next from "i18next";
import { checkAndGetLocalStorageValue } from "../../../features/utils"
import PhoneInput2 from "react-phone-input-2";

const formSchema = schema(({ string }) => ({
  phone: string,
}));

let valuedata;
let value = '';
const onChange = (e) =>{
  const re = /^[0-9\b]+$/;
  if (e.target.value === '' || re.test(e.target.value)) {
     this.setState({value: e.target.value})
  }
 } 
export default ({ state, actions, history, nextStepName, setState }) => ( 
  <div className="content-width mt-3">
    <h4 className="text-center">
      <Trans i18nKey="findcareoption.Careoptions.Concierge.ConciergeCareHeading">
        Request Concierge Care
      </Trans>
    </h4>

    <Form
      fields={state.triageRequest.serviceRequest}
      onValidate={(data) => {        
        const errors = {};       
        var s = formSchema(data);
        if ((data.phone).length <= 3) errors.phone = "REQUIRED"
        if (data.locationType === "-1") errors.locationType = "INVALID";
        if (Object.keys(errors).length) return errors;
      }}
      onSubmit={(data) => {
        setState({
          valuedata: data,
        });
        actions.setTriageServiceRequest(data);
        state.triageRequest.data = data;
        actions.submitTriageConciergeCare(state, valuedata);
        history.push(`/find-care-options/patientdetails-confo-screen`);
      }}
    >
      {({ fields, invalidFields, isValid, setFields }) => (
        <>                
									<div className="pt-1 pb-2">
									<PhoneInput2
									  country={"us"}				
									  inputProps={{
										name: "phone",
									  }}                      
									  inputClass={cx(invalidFields.phone ? "is-error" : "")}
									  value={
										state.triageRequest.data
												? state.triageRequest.data.phone
												: fields.phone
									  }
									  placeholder={i18next.t(
										"findcareoption.Careoptions.PhoneNumber"
									)}
									  Validationmsg={i18next.t(
										"findcareoption.Careoptions.telemedicine.PhoneValidationmsg"
									  )}
									/>																		
								  </div> 
          <input
            type="email"
            name="email"
            placeholder={i18next.t("findcareoption.Careoptions.EmailAddress")}
            defaultValue={
              checkAndGetLocalStorageValue("userEmail")
                ? checkAndGetLocalStorageValue("userEmail")
                : fields.email
            }
          />

          <select
            name="locationType"
            className={cx(invalidFields.locationType ? "is-error" : "")}
            value={fields.locationType}
            onChange={(e) =>
              setFields({
                locationType: e.target.value,
                hotelname: "",
                roomnumber: "",
              })
            }
          >
            <option value="-1">
              {" "}
              {i18next.t(
                "findcareoption.Careoptions.housevisit.HousevisitDrpdnValue1"
              )}
            </option>
            <option value="1">
              {i18next.t(
                "findcareoption.Careoptions.housevisit.HousevisitDrpdnValue2"
              )}
            </option>
            <option value="2">
              {i18next.t(
                "findcareoption.Careoptions.housevisit.HousevisitDrpdnValue3"
              )}
            </option>
          </select>
          {fields.locationType === "2" ? (
            <>
              <input
                type="text"
                name="hotelname"
                placeholder={i18next.t("findcareoption.Careoptions.HotelName")}
                defaultValue={fields.hotelname}
              />
              <input
                type="text"
                name="roomnumber"
                maxLength="5" 
                onChange={onChange}
                placeholder={i18next.t("findcareoption.Careoptions.Room")}
                defaultValue={fields.roomnumber}
              />
            </>
          ) : (
            <></>
          )}

          <input
            type="text"
            name="location"
            className="mt-2"
            placeholder={i18next.t("findcareoption.Careoptions.StreetAdress")}
            defaultValue={
              state.triageRequest.location.hasOwnProperty("name")
                ? state.triageRequest.location.name
                : fields.location
            }
          />
          <input
            type="text"
            name="postalCode"
            placeholder={i18next.t("findcareoption.Careoptions.PostalCode")}
            defaultValue={fields.postalCode}
          />
          <div className="row row-gutter-1">
            <div className="col col-md-6">
              <input
                type="text"
                name="country"
                placeholder={i18next.t("findcareoption.Careoptions.country")}
                defaultValue={
                  state.triageRequest.location.hasOwnProperty("parts")
                    ? state.triageRequest.location.parts.country
                    : fields.country
                }
              />
            </div>
            <div className="col col-md-6">
              <input
                type="text"
                name="state"
                placeholder={i18next.t("findcareoption.Careoptions.state")}
                defaultValue={
                  state.triageRequest.location.hasOwnProperty("parts")
                    ? state.triageRequest.location.parts
                        .administrative_area_level_1
                    : fields.state
                }
              />
            </div>
          </div>
          <input
            type="text"
            name="city"
            placeholder={i18next.t("findcareoption.Careoptions.city")}
            defaultValue={
              state.triageRequest.location.hasOwnProperty("parts")
                ? state.triageRequest.location.parts.locality
                : fields.city
            }
          />

          <textarea
            name="notes"
            className="mt-2"
            rows="4"
            placeholder={i18next.t("findcareoption.Careoptions.notes")}
            defaultValue={fields.notes}
          ></textarea>

          <button
            type="submit"            
            className={cx(
              "button standby-button standby-button-gradient standby-button-full-width standby-button-gradient-green" /* : 'btn-screen-nav--disabled' */
            )}
          >
            <Trans i18nKey="findcareoption.Careoptions.housevisit.Next">
              Next
            </Trans>
          </button>

          {isValid ? (
            ""
          ) : (
            <p
              style={{ marginBottom: "20px" }}
              className="color-dark-gray text-small"
            >
              <Trans i18nKey="findcareoption.Careoptions.housevisit.HouseVisitvalidationMsg">
                Please make sure to fill all required fields.
              </Trans>
            </p>
          )}
        </>
      )}
    </Form>
    <div className="standby-page-header standby-page-header-center pb-3" >
      <Link
        className="standby-button-back"
        to={`/find-care-options/care-options`}
      >
        <div className="icon">
          <svg
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="10"
            viewBox="0 0 1024 1024"
          >
            <path d="M128.033 512.054l448.036-448.036 107.836 107.836-340.099 340.2 340.099 340.2-107.836 107.736-447.836-447.836z" />
          </svg>
        </div>
        <Trans i18nKey="findcareoption.Careoptions.telemedicine.Cancelrequest">
          Cancel Request
        </Trans>
      </Link>
    </div>
  </div>
);
